module.exports = __webpack_public_path__ + "img/8_74.60152f5e.png";